import styled from 'styled-components'

export const Container = styled.span`
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colours.blue[50]};
    :hover {
      text-decoration: underline;
    }
  }
`

export const Link = styled.a``
